import { setSendMessagePending } from './actions';
import { trackMessageSent } from './tracking';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage, prepareMessageReply } from '../../utils/messageUtils';
import { sendWsMessage } from '../wsMessage';
import { IWsMessageReply } from '../wsMessage/types';

interface ISendMessageParams {
  text: string;
  chatId: string;
  messageId?: string;
  payload?: string | null;
  reply?: IWsMessageReply | null;
}

export const sendMessage =
  ({ text, chatId, messageId, payload, reply }: ISendMessageParams): TThunkAction<void> =>
  async (dispatch, getState, { custom: { messagesMap } }) => {
    const {
      user: { userId },
    } = getState();

    const messageReply = prepareMessageReply({ messagesMap, replyToMessageId: reply?.messageId });

    const message = createOutcomingMessage({ text, chatId, userId, payload, reply: messageReply });

    trackMessageSent({ chatId, messageId: message.messageId, isReply: Boolean(messageReply) });

    dispatch(
      setSendMessagePending({
        message,
        messageId: messageId || message.messageId,
        messagesMap,
      }),
    );

    await dispatch(sendWsMessage({ message, reply }));
  };
